<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container fluid class="fill-height">
        <v-row class="flex-child fill-height" style="max-width: none;">
            <v-col cols="12" md="3">
                <v-sheet class="fill-height" elevation="2">
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-chip class="ma-2 Headline" color="primary">
                                {{label.preview}}
                            </v-chip>
                        </v-col>
                    </v-row>
                    <v-row align="center" class="my-4" justify="center">
                        <v-col cols="12" md="10">
                            <e-tree v-model="treeSelected" :active="active" :overlay="treeDisabled" :open="treeOpen" :items="items" :openOnClick="openOnClick"
                                    @selectedVal="selectedVal" @selectedOldVal="selectedOldVal"></e-tree>
                        </v-col>
                    </v-row>
                </v-sheet>
            </v-col>
            <v-col cols="12" md="9">
                <v-sheet class="fill-height" elevation="2">
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-chip class="ma-2 Headline" color="success">
                                {{label.addOperation}}
                            </v-chip>

                            <v-chip class="ma-2 Headline float-right" color="error" v-if="!saveDisabled"
                                    @click="initializationState">
                                <v-icon>mdi-backup-restore</v-icon>
                                {{label.cancelOperation}}
                            </v-chip>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12" md="4">
                            <v-card>
                                <v-form ref="form">
                                    <v-container fluid class="fill-height">
                                        <v-row>
                                            <v-col>
                                                <v-text-field :disabled="textDisabled" :rules="[rules.required]"
                                                              hide-details :label="label.name" @input="updateName"
                                                              v-model="formData.name"/>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-text-field :disabled="textDisabled" :rules="[rules.required]"
                                                              hide-details :label="label.code"
                                                              v-model="formData.code"/>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-row justify="center">
                                                    <v-btn class="mx-2" :disabled="udButtonsDisabled" large
                                                           @click="updateButtonStatus" color="primary">
                                                        <v-icon dark>mdi-pencil</v-icon>
                                                        {{label.update}}
                                                    </v-btn>
                                                    <v-btn class="mx-2" :disabled="udButtonsDisabled" large
                                                           color="error"
                                                           @click="deleteOperation"
                                                    >
                                                        <v-icon dark>mdi-delete</v-icon>
                                                        {{label.delete}}
                                                    </v-btn>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-row justify="center">
                                                    <v-btn class="mx-2" :disabled="buttonsDisabled" large
                                                           color="success" @click="addOperation">
                                                        <v-icon dark>mdi-plus-thick</v-icon>
                                                        {{label.add}}
                                                    </v-btn>
                                                    <v-btn class="mx-2" :disabled="subButtonsDisabled" large
                                                           color="success" @click="addSubOperation">
                                                        <v-icon dark>mdi-plus-thick</v-icon>
                                                        {{label.addSub}}
                                                    </v-btn>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-form>
                                <v-row justify="center">
                                    <v-btn class="mb-3" large width="90%" :disabled="saveDisabled" color="success"
                                           @click="saveOperation"
                                    >{{label.save}}
                                    </v-btn>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="8">

                        </v-col>
                    </v-row>
                </v-sheet>
            </v-col>
        </v-row>
    </v-container>
</template>
<style></style>
<script>
    import ETree from '@/components/tree/ETree'
    import Mock from 'mockjs'

    export default {
        data() {
            return {
                //文本操作状态   可用作图标的显示
                textDisabled: true,
                //操作区按钮
                buttonsDisabled: true,
                //子集添加
                subButtonsDisabled: true,
                //修改删除操作
                udButtonsDisabled: true,
                //保存按钮
                saveDisabled: true,
                //树是否禁用
                treeDisabled: false,

                isUpdate: true,

                formData: {
                    id: '',
                    name: '',
                    code: '',
                    parentId: ''
                },
                label: {
                    preview: this.$vuetify.lang.t('$vuetify.custom.operation.preview'),
                    addOperation: this.$vuetify.lang.t('$vuetify.custom.operation.addOperation'),
                    cancelOperation: this.$vuetify.lang.t('$vuetify.custom.giveUpOperation'),
                    update: this.$vuetify.lang.t('$vuetify.custom.operation.update'),
                    delete: this.$vuetify.lang.t('$vuetify.custom.operation.delete'),
                    add: this.$vuetify.lang.t('$vuetify.custom.operation.add'),
                    addSub: this.$vuetify.lang.t('$vuetify.custom.operation.addSub'),
                    save: this.$vuetify.lang.t('$vuetify.custom.preservation'),
                    name: this.$vuetify.lang.t('$vuetify.custom.operation.name'),
                    code: this.$vuetify.lang.t('$vuetify.custom.operation.code')
                },
                openOnClick: false,
                items: [],
                oldItems: [],
                treeSelected: [],
                active: [],
                rules: {
                    required: value => !!value || '请输入'
                },
                treeOpen: []
            }
        },
        created() {
            this.loadOperation()
        },
        mounted() {

        },
        computed: {},
        methods: {
            loadOperation() {
                this.$api.sysPermission.selectOperation().then(data => {
                    this.items = data.data
                    this.initItems(this.items)
                    this.oldItems = this.$utils.arrayUtil.deepClone(this.items)
                    this.initializationState()
                })
            },
            updateName() {
                let item = this.items
                for (let index of this.$utils.treeUtil.findSubscriptDefault(this.items, this.treeSelected[0])) {
                    if (item.children) {
                        item = item['children'][index]
                    } else {
                        item = item[index]
                    }
                }
                item.name = this.formData.name
                //this.isUpdate = true
            },
            deleteOperation() {
                this.$dialog.confirm(this.$vuetify.lang.t('$vuetify.custom.operation.deleteQuery'), '提示', () => {
                    this.$api.sysPermission.deletePermission(
                        this.formData.id
                    ).then(data => {
                        if (data.flag) {
                            this.loadOperation()
                        }
                    })
                })
            },
            selectedVal(val) {
                //this.treeSelected = val
                this.treeOpen.push(val[0])
                let item = this.$utils.treeUtil.findItemDefault(this.items, val[0])
                this.formData.name = item.name
                this.formData.code = item.code
                this.formData.id = item.id
                this.udButtonsDisabled = false
                this.buttonsDisabled = false
                this.subButtonsDisabled = false
                if (item.type == 0) {
                    this.udButtonsDisabled = true
                    this.udButtonsDisabled = true
                    this.buttonsDisabled = true
                } else {
                    this.subButtonsDisabled = true
                }
            },
            selectedOldVal(oldVal){
                //this.treeSelected = []
                this.$utils.arrayUtil.removeArray(this.treeOpen,oldVal[0])
                this.initializationState()
            },
            addOperation() {
                this.isUpdate = false
                let item = this.items
                let indexs = this.$utils.treeUtil.findSubscriptDefault(this.items, this.treeSelected[0])
                for (let i = 0; i < indexs.length - 1; i++) {
                    if (item.children) {
                        item = item['children'][[indexs[i]]]
                    } else {
                        item = item[[indexs[i]]]
                    }
                }
                this.formData = {
                    id: 'newOperation',
                    name: '',
                    code: '',
                    parentId: indexs.length == 1?'':item.id
                }
                if (indexs.length == 1) {
                    item.push({
                        id: this.formData.id,
                        name: this.formData.name,
                        code: this.formData.code,
                        icon: 'mdi-opera',
                        iconType: '0'
                    })
                } else {
                    item.children.push({
                        id: this.formData.id,
                        name: this.formData.name,
                        code: this.formData.code,
                        icon: 'mdi-opera',
                        iconType: '0'
                    })
                }
                this.treeSelected = 'newOperation'
                this.active = ['newOperation']
                this.updateButtonStatus()
            },
            addSubOperation() {
                this.isUpdate = false
                let item = this.items
                for (let index of this.$utils.treeUtil.findSubscriptDefault(this.items, this.treeSelected[0])) {
                    if (item.children) {
                        item = item['children'][index]
                    } else {
                        item = item[index]
                    }
                }
                this.formData = {
                    id: 'newOperation',
                    name: '',
                    code: '',
                    parentId: item.id
                }
                if(!item.children){
                    item.children = []
                }
                item.children.push({
                    id: this.formData.id,
                    name: this.formData.name,
                    code: this.formData.code,
                    icon: 'mdi-opera',
                    iconType: '0'
                })
                this.treeSelected = 'newOperation'
                this.active = ['newOperation']
                this.updateButtonStatus()
            },
            saveOperation() {
                if (this.isUpdate) {
                    this.$api.sysPermission.updateOperation(this.formData).then(data => {
                        if (data.flag) {
                            this.loadOperation()
                        }else{
                            debugger
                            this.$dialog.alert(data.msg,'错误');
                        }
                    })
                } else {
                    this.$api.sysPermission.addOperation(this.formData).then(data => {
                        if (data.flag) {
                            this.loadOperation()
                        }else{
                            debugger
                            this.$dialog.alert(data.msg,'错误');
                        }
                    })
                }
            },
            //公共方法
            /**
             * 初始化状态
             */
            initializationState() {
                this.formData = {
                    id: '',
                    name: '',
                    code: '',
                    parentId: ''
                }
                //this.active = []
                this.buttonsDisabled = true
                this.udButtonsDisabled = true
                this.subButtonsDisabled = true
                this.textDisabled = true
                this.treeDisabled = false
                this.saveDisabled = true
                this.items = this.$utils.arrayUtil.deepClone(this.oldItems)
            },
            initItems(items) {
                for (let item of items) {
                    item.iconType = "0";
                    if (item.type == 0) {
                        item.icon = 'mdi-menu'
                    } else {
                        item.icon = 'mdi-opera'
                    }
                    if (item.children.length != 0) {
                        this.initItems(item.children)
                    } else {
                        item.children = undefined
                    }
                }
            },
            disableAllButtons() {
                this.buttonsDisabled = true
                this.udButtonsDisabled = true
                this.subButtonsDisabled = true
            },
            //操作区按钮点击后状态
            updateButtonStatus() {
                this.textDisabled = false
                this.disableAllButtons()
                this.treeDisabled = true
                this.saveDisabled = false
            }
        }
        ,
        components: {
            ETree
        }
        ,
    }
</script>
